import React, { Component } from 'react'
import { Close } from './icons'
import DownloadForm from './download-form'

class BasicContent extends Component {

  state = {
    lightbox: false,
  }

  render() {

    let { title, content, noPaddingTop, noPaddingBottom, researchInsights, download, formTitle, formThanks, buttonText, sendTo } = this.props
    let { lightbox } = this.state

    return (
      <>
        <section className={`basic-content${noPaddingTop ? ' basic-content--npt' : ''}${noPaddingBottom ? ' basic-content--npb' : ''}`} id={researchInsights ? 'download' : ''}>
          <div className='basic-content__inner'>
            <h1>{ title }</h1>
            <div className='basic-content__content' dangerouslySetInnerHTML={{ __html: content }} />
            { researchInsights && 
              <button className='btn' onClick={() => this.setState({lightbox: !lightbox})}>
                {buttonText ? buttonText : 'Sign Up to Download'}
              </button>
            }
          </div>
        </section>
        { researchInsights &&
          <div className={`popup${lightbox ? ' active' : ''}`}>
            <div className='testimonial-popup__overlay' />
            <div className='testimonial-popup'>
              <button 
                className=''
                onClick={() => this.setState({ lightbox: false })}
              >
                <Close color='#FFFFFF' />
              </button>
              <div className='testimonial-popup__details'>
                <DownloadForm sendTo={sendTo ? sendTo : 'todd@kollosche.com.au'} subject={buttonText} formTitle={formTitle} formThanks={formThanks} download={download?.publicUrl} />
              </div>
            </div>
          </div>
        }
      </>
    )
  }
}

export default BasicContent
